/**
 * Thread id of the comment card currently expanded in the editor comment sidebar
 * (same id as in sudowrite://comment/<id>). Used to mark the focused thread in agentic context.
 */
let current: string | null = null;
let sidebarOrderDocumentId: string | null = null;
let sidebarOrderCommentIds: string[] = [];

export function setActiveManuscriptCommentThreadIdForAgent(id: string | null | undefined): void {
  if (id == null || String(id).trim() === "") {
    current = null;
  } else {
    current = String(id).trim();
  }
}

export function getActiveManuscriptCommentThreadIdForAgent(): string | null {
  return current;
}

export function setCommentSidebarOrderForAgent(documentId: string | null | undefined, orderedCommentIds: string[] | null | undefined): void {
  const doc = typeof documentId === "string" ? documentId.trim() : "";
  if (!doc) {
    sidebarOrderDocumentId = null;
    sidebarOrderCommentIds = [];
    return;
  }
  sidebarOrderDocumentId = doc;
  sidebarOrderCommentIds = Array.isArray(orderedCommentIds)
    ? orderedCommentIds.map((id) => String(id).trim()).filter(Boolean)
    : [];
}

export function getCommentSidebarOrderForAgent(documentId: string | null | undefined): string[] | undefined {
  const doc = typeof documentId === "string" ? documentId.trim() : "";
  if (!doc) return undefined;
  if (!sidebarOrderDocumentId || sidebarOrderDocumentId !== doc) return undefined;
  return sidebarOrderCommentIds.length > 0 ? [...sidebarOrderCommentIds] : undefined;
}
